<template>
  <ElButton
    icon="el-icon-delete"
    type="danger"
    size="small"
    plain
    v-bind="$attrs"
    :loading="loading"
    class="cancel-publish-request"
    @click="cancelPublishRequestAfterConfirm"
  >
    {{ $t('APP.ACTIONS.CANCEL_PUBLISH_REQUEST_TITLE') }}
  </ElButton>
</template>

<script>
import packageName from '@/mixins/packageName';
import Release from '@/api/app-releases';
import { mapActions } from 'vuex';
import { REPLACE_RELEASE } from '@/store/types';

export default {
  name: 'CancelPublishRequest',
  mixins: [packageName],
  props: {
    releaseId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    ...mapActions({ replaceReleaseInStore: REPLACE_RELEASE }),
    cancelPublishRequestAfterConfirm() {
      this.confirmCancelation()
        .then(() => {
          this.cancelPublishRequest();
        })
        .catch(() => {});
    },
    confirmCancelation() {
      return this.$confirm(
        this.$t('APP.RELEASES.CANCELATION_WARNING'),
        this.$t('WARNING'),
        {
          confirmButtonText: this.$t(
            'APP.ACTIONS.CANCEL_PUBLISH_REQUEST_TITLE',
          ),
          cancelButtonText: this.$t('CANCEL'),
          confirmButtonClass: 'cancel-publish-request__delete-confirm-button',
          type: 'error',
        },
      );
    },
    cancelPublishRequest() {
      this.loading = true;
      const params = {
        id: this.releaseId,
        packageName: this.packageName,
      };
      return Release.cancelReviewRequest(params)
        .then(release => {
          this.replaceReleaseInStore(release);
        })
        .catch(({ message }) => {
          if (message) {
            this.$message.error(message);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
<style lang="scss">
.cancel-publish-request {
  margin-left: $global-margin;
  @include rtl() {
    margin-left: 0;
    margin-right: $global-margin;
  }

  @include breakpoint(medium down) {
    /* stylelint-disable-next-line */
    & > span {
      display: none;
    }
  }

  &__delete-confirm-button {
    background-color: $alizarin;
    border: 0;

    &:hover,
    &:focus {
      background-color: $alizarin;
    }
  }
}
</style>
